export const AllApprovedModalConstants = {
    HEADER: "Success",
    MESSAGE: "All tickets have been submitted successfully",
    RETURN_TO_TKT_UPLOAD: "Return to Ticket Upload",
    GO_TO_TKT_PROCESSING: "Go to Ticket Processing",
    BUTTON_CLASS: "actionButtonClass",
}